module.exports = __webpack_public_path__ + "static/media/gem.712f3e23.png";